<script setup lang="ts">
import { PaymentsEmbed } from '@/Pejer/tables/Payments'
import FundsLocationBadge from './FundsLocationBadge.vue'

defineProps<{
  payment: PaymentsEmbed.ListItem
}>()
</script>
<template>
  <div class="flex flex-col items-start gap-1">
    {{ payment.connectedAccountSeller?.name }}
    <FundsLocationBadge :payment="payment" />
  </div>
</template>
